module.exports = __webpack_public_path__ + "media/fonts/EHSMB-c6f9f40bb377408a9b4edfb1b8978516.woff";